import { Expose, Type } from 'class-transformer';
import { GetGuestUserDto } from './get-guest-user.dto';
import { GetGuestFloorDto } from './get-guest-floor.dto';
import { GetGuestCompanyDto } from './get-guest-company.dto';
import { GetGuestBuildingDto } from './get-guest-building.dto';
import { SpecialNeedEnum } from '../../../guest-management/enum/special-need.enum';
import { GetGuestPlaceDto } from './get-guest-place.dto';
import { GuestInvitationPlaceDto } from '../../../guest-management/dto/response/guest-invitation-place.dto';

//TODO : need to change floor and building to real dto instead any type
export class GetGuestResponseGuestDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'phone' })
  phone: string;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'arriving_on' })
  arrivingOn: number;
  @Expose({ name: 'need_escort' })
  needEscort: boolean;
  @Expose({ name: 'allow_parking' })
  allowParking: boolean;
  @Expose({ name: 'with_car' })
  withCar: boolean;
  @Expose({ name: 'license_number' })
  licenseNumber: string;
  @Expose({ name: 'parking_number' })
  parkingNumber: string;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'building_id' })
  buildingId: number;
  @Expose({ name: 'building' })
  building: any;
  @Expose({ name: 'floor_id' })
  floorId: number;
  @Expose({ name: 'floor' })
  floor: GetGuestFloorDto;
  @Expose({ name: 'floors' })
  floors?: string[];
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'message' })
  message: string;
  @Expose({ name: 'inviter_name' })
  inviterName: string;
  @Expose({ name: 'special_need' })
  specialNeed?: SpecialNeedEnum;
  @Expose({ name: 'parking_floor_number' })
  parkingFloorNumber: string;
  @Expose({ name: 'guest_floors' })
  guestFloors: string[];
  @Expose({ name: 'place' })
  @Type(() => GetGuestPlaceDto)
  place: GetGuestPlaceDto;
  @Expose({ name: 'user' })
  @Type(() => GetGuestUserDto)
  user: GetGuestUserDto;
  @Expose({ name: 'company' })
  @Type(() => GetGuestCompanyDto)
  company: GetGuestCompanyDto;
  @Expose({ name: 'buildings' })
  @Type(() => GetGuestBuildingDto)
  buildings: GetGuestBuildingDto[];
  @Expose({ name: 'created_at' })
  createdAt: number;
  @Expose({ name: 'invitation_place' })
  @Type(() => GuestInvitationPlaceDto)
  invitationPlace: GuestInvitationPlaceDto;
}
